import React from 'react';
import UseContext from "hooks/useContext";

const Modalstructure = ({isShowing, children}) => {
    const { modalType } = UseContext();
    
    // Modales de validation d'identité qui nécessitent la largeur étendue
    const wideModals = [
        'ad_file_accept_identity',
        'ad_file_accept_visa',
        'ad_file_accept_simple',
        'ad_file_accept_card_vitality',
        'ad_file_refuse',
        'ad_file_view'
    ];
    
    const isWideModal = wideModals.includes(modalType);
    const maxWidthClass = isWideModal ? 'max-w-[1400px]' : 'max-w-2xl';
    
    return (
        <>
            {isShowing ?
                <>

                    <div className="flex fixed justify-center items-center inset-0 z-50 outline-none focus:outline-none">
                        <div className={`relative w-full ${maxWidthClass} my-6 mx-auto h-full py-6 overflow-y-auto no-scrollbar`}>
                            <div
                                className={`relative flex flex-col ${maxWidthClass} rounded-lg border-0 sh-lg bg-white outline-none focus:outline-none max-h-full overflow-y-auto`}>
                                {children}
                            </div>
                        </div>
                    </div>
                    <div className="opacity-70 fixed inset-0 z-40 bg-gray-700"></div>
                </> : null}
        </>
    );
};

export default Modalstructure;